import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Layout, Row, Col, PageHeader, Button, Icon, List, Card } from 'antd'

import CouponType from './CouponType'
import CouponTypePopup from '@components/Popup/CouponTypePopup'
import CouponsListPopup from '@components/Popup/CouponsListPopup'
@inject((store: any) => {
    const { popupStore, couponTypesStore, subscriptionsStore, servicesStore } = store
    return { popupStore, couponTypesStore, subscriptionsStore, servicesStore }
})
@observer
export default class Coupons extends Component<any> {
    async componentDidMount() {
        const { servicesStore, couponTypesStore, subscriptionsStore } = this.props
        await servicesStore.getList()
        await subscriptionsStore.getSubscriptions()
        await couponTypesStore.getList()
    }
    render() {
        const {
            popupStore: { togglePopup },
            couponTypesStore: { list, resetEditCouponType }
        } = this.props
        return (
            <Layout>
                <PageHeader
                    onBack={() => window.history.back()}
                    title="קופונים"
                    subTitle="רשימת סוגי הקופונים במערכת"
                ></PageHeader>
                <Row style={{ padding: '0 2rem' }}>
                    <Col>
                        <Card
                            bodyStyle={{ padding: '0 1rem' }}
                            title={
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div>נמצאו {list.length} סוגי קופונים</div>
                                    <div>
                                        <Button
                                            type="primary"
                                            onClick={() => {
                                                resetEditCouponType()
                                                togglePopup('couponType')
                                            }}
                                            style={{ fontSize: '1rem' }}
                                        >
                                            <Icon type="plus" /> הוסף סוג קופון
                                        </Button>
                                    </div>
                                </div>
                            }
                        >
                            <List
                                dataSource={list}
                                renderItem={item => (
                                    <List.Item style={{ backgroundColor: `${item['active'] ? 'white' : '#f5c9c9'}` }}>
                                        <CouponType couponType={item} />
                                    </List.Item>
                                )}
                            />
                        </Card>
                    </Col>
                </Row>
                <CouponTypePopup />
                <CouponsListPopup />
            </Layout>
        )
    }
}
